import { isNullOrUndefined } from 'util';

export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return '$' + negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
    }
};

export function emptyStringIfNull(obj) {
    if (obj == null) {
        return "";
    }

    return obj.toString();
}

export function extend(defaults, options) {
    var extended = {};
    var prop;
    for (prop in defaults) {
        if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
            extended[prop] = defaults[prop];
        }
    }
    for (prop in options) {
        if (Object.prototype.hasOwnProperty.call(options, prop)) {
            extended[prop] = options[prop];
        }
    }
    return extended;
}

export function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


export function isOutOfStock(supplyLocation, item) {

     if (isNullOrUndefined(supplyLocation) || supplyLocation == '') {
         if (item.stockAvailability) {

             // If all are OutOfStock then hide
             var notOutOfStock = item.stockAvailability.filter((location) => {
                 return location.status != "OutOfStock";
             });

             if (notOutOfStock.length > 0) {
                 return false;
             }
         }

         return true;
    }


    var currentLocation = item.stockAvailability.filter((location) => {
        return supplyLocation == location.locationName;
    });

   
    if (isNullOrUndefined(currentLocation[0]) || isNullOrUndefined(currentLocation[0].status)) {
        return true;
    }

    if (currentLocation[0].status == "OutOfStock") {
        return true;
    }
   
    return false;
}
